// Editable product collection — each product's name, price, category, details,
// photo, visibility and order can be edited independently below.

export const COMPANY = {
  legalName: "VIGO SOLUTIONS SDN. BHD.",
  ssm: "202601037350 (1699445-P)",
  address: "NO. 16X, JALAN KELAB CINTA SAYANG, TAMAN RIA JAYA, SUNGAI PETANI, KEDAH, MALAYSIA.",
  email: "louisteoh66@gmail.com",
  phoneDisplay: "+6011-51270510",
  phoneTel: "+601151270510",
  whatsapp: "601151270510",
  location: "Sungai Petani, Kedah, Malaysia",
};

export const CATEGORIES = [
  "Consoles",
  "EDC Toys",
  "Collectibles",
  "Model Kits & Building Sets",
];

export const formatRM = (n) =>
  `RM ${Number(n).toLocaleString("en-MY", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const PRODUCTS = [
  {
    id: "product-01",
    name: "PS5 Digital Edition 825GB Marvel’s Wolverine Battle Limited Edition Bundle PS5 Console",
    price: 3999.0,
    category: "Consoles",
    image: "/assets/product-01.webp",
    visible: true,
    details: [
      "Limited edition bundle console.",
      "Contact us via WhatsApp to confirm availability, delivery charges and payment.",
    ],
  },
  {
    id: "product-02",
    name: "Nintendo Switch V2 — Neon Blue/Neon Red Joy-Con",
    price: 1899.0,
    category: "Consoles",
    image: "/assets/product-02.webp",
    visible: true,
    details: [
      "Nintendo Switch V2 console with Neon Blue and Neon Red Joy-Con.",
      "Contact us via WhatsApp to confirm availability, delivery charges and payment.",
    ],
  },
  {
    id: "product-03",
    name: "Lautie LOTTO EDC Toys",
    price: 2599.0,
    category: "EDC Toys",
    image: "/assets/product-03.webp",
    visible: true,
    confirmEdition: true,
    details: [
      "Supplied materials — EDC Show Edition: Titanium + Brass + Mokume.",
      "Supplied materials — Titanium + Brass + Zirconium.",
      "Please confirm your preferred edition with us when ordering.",
    ],
  },
  {
    id: "product-04",
    name: "DJG Destroyer",
    price: 3499.0,
    category: "EDC Toys",
    image: "/assets/product-04.jpg",
    visible: true,
    details: ["Zirconium + Titanium set."],
  },
  {
    id: "product-05",
    name: "BE@RBRICK 2G Reserve Ver. 1000%",
    price: 13998.0,
    category: "Collectibles",
    image: "/assets/product-05.webp",
    visible: true,
    details: ["Estimated height: 700mm.", "Weight: 7000g."],
    attribution: "© Hajime Sorayama; Courtesy of NANZUKA; BE@RBRICK™ & © 2001–2020.",
  },
  {
    id: "product-06",
    name: "BE@RBRICK x KAWS OriginalFake 6th Anniversary 1000% — Red",
    price: 41987.0,
    category: "Collectibles",
    image: "/assets/product-06.png",
    visible: true,
    details: ["Brand new."],
  },
  {
    id: "product-07",
    name: "BANDAI Star Wars Perfect Grade 1/72 Millennium Falcon Model Kit",
    price: 2199.0,
    category: "Model Kits & Building Sets",
    image: "/assets/product-07.webp",
    visible: true,
    details: ["Perfect Grade 1/72 scale model kit.", "New / sealed."],
  },
  {
    id: "product-08",
    name: "LEGO Star Wars The Force Unleashed Rogue Shadow 7672",
    price: 4299.0,
    category: "Model Kits & Building Sets",
    image: "/assets/product-08.webp",
    visible: true,
    details: ["Retired set.", "Brand new in box, sealed."],
  },
  {
    id: "product-09",
    name: "LEGO Star Wars 7283 Ultimate Space Battle",
    price: 9388.0,
    category: "Model Kits & Building Sets",
    image: "/assets/product-09.webp",
    visible: true,
    details: [
      "Complete set.",
      "Contact us for packaging and contents details before ordering.",
    ],
  },
  {
    id: "product-10",
    name: "LAUTIE Bit09 Mechanical Style Titanium Blue Fidget Spinner",
    price: 1888.0,
    category: "EDC Toys",
    image: "/assets/product-10.webp",
    visible: true,
    details: ["Mechanical-style titanium fidget spinner, blue finish."],
  },
];
